export const importColumns = [
  {
    accessorKey: "sNo",
    header: "Serial #",
    size: 150,
  },
  {
    accessorKey: "vehicleNumber",
    header: "NTOS Vehicle #",
    size: 200,
  },
  {
    accessorKey: "webocVehicleNumber",
    header: "WeBoc Vehicle #",
    size: 200,
  },
  {
    accessorKey: "isVGILReceived",
    header: "VGIL from WeBOC",
    size: 200,
  },
  {
    accessorKey: "isGDIOReceived",
    header: "GDIO from WeBOC",
    size: 200,
  },
  {
    accessorKey: "isIHCOReceived",
    header: "IHCO from WeBOC",
    size: 200,
  },
  {
    accessorKey: "isSRCOSent",
    header: "SRCO from NTOS",
    size: 200,
  },
  {
    accessorKey: "isECMOReceived",
    header: "ECMO from WeBOC",
    size: 200,
  },

  {
    accessorKey: "isCRLOReceived",
    header: "CRLO from WeBOC",
    size: 200,
  },

  {
    accessorKey: "isGTOOSent",
    header: "GTOO from NTOS",
    size: 200,
  },
];
export const exportColumns = [
  {
    accessorKey: "sNo",
    header: "Serial #",
    size: 150,
  },
  {
    accessorKey: "vehicleNumber",
    header: "NTOS Vehicle #",
    size: 180,
  },
  {
    accessorKey: "webocVehicleNumber",
    header: "WeBoc Vehicle #",
    size: 180,
  },
  {
    accessorKey: "isOPIAReceived",
    header: "OPIA from WeBOC",
    size: 180,
  },
  {
    accessorKey: "isOGIESent",
    header: "OGIE from NTOS",
    size: 180,
  },
  {
    accessorKey: "isOGDEReceived",
    header: "OGDE from WeBOC",
    size: 180,
  },
  {
    accessorKey: "isOEHCReceived",
    header: "OEHC from WeBOC",
    size: 180,
  },
  {
    accessorKey: "isOSRCsent",
    header: "OSRC from NTOS",
    size: 180,
  },
  {
    accessorKey: "isOECMReceived",
    header: "OECM from WeBOC",
    size: 180,
  },
  {
    accessorKey: "isOCRLReceived",
    header: "OCRL from WeBOC",
    size: 180,
  },
  {
    accessorKey: "isOGTESent",
    header: "OGTE from NTOS",
    size: 180,
  },
];

export const imortInfoColumn = [
  {
    accessorKey: "fromWeBOC",
    header: "Messages From WeBOC",
    size: 180,
  },
  {
    accessorKey: "fromNTOS",
    header: "Messages From NTOS",
    size: 180,
  },
];
export const exportInfoColumn = [
  {
    accessorKey: "fromWeBOC",
    header: "From WeBOC",
    size: 180,
  },
  {
    accessorKey: "fromNTOS",
    header: "From NTOS",
    size: 180,
  },
];
